export enum AssetMapColorMode {
	FIRST_INCOMPLETE_STEP = "FIRST_INCOMPLETE_STEP",
	LAST_COMPLETED_STEP = "LAST_COMPLETED_STEP",
	STATUS = "STATUS",
}

export enum AssetTimelineItemType {
	CREATED = "created",
	ATTACHMENT = "attachment",
	PROCEDURE = "procedure",
	FIELD_VALUES = "field-values",
	COMMENT = "comment",
	ISSUE_ASSOCIATION = "issue-association",
	IDENTIFIER_VALUE = "identifier-value",
	FORM_SUBMISSION = "form-submission",
}
